var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "backArrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.481,
    height: 11.669,
    viewBox: "0 0 18.481 11.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M11.122,10.368a.816.816,0,0,1,0,1.18L6.574,15.958l2.907,2.819,1.642,1.591a.817.817,0,0,1,0,1.18.879.879,0,0,1-1.217,0l-5.155-5a.816.816,0,0,1,0-1.18l5.155-5a.878.878,0,0,1,1.217,0Z",
    transform: "translate(-4.498 -10.123)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M5.625,18c0-.621.318-1.125.711-1.125H21.268c.393,0,.711.5.711,1.125s-.318,1.125-.711,1.125H6.336C5.943,19.125,5.625,18.621,5.625,18Z",
    transform: "translate(-3.498 -12.166)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.32ba4b3eec183eb5e22e709c176fff12.svg";
export { ForwardRef as ReactComponent };